import React from 'react';

/**
 * AntD Select icon wrapper.
 * Props:
 *  - startIcon: ReactNode (left)
 *  - endIcon: ReactNode (right)
 *  - children: <Select ... />
 *
 * Just wrap your <Select>. It injects padding so icons fit.
 */
const SelectIconWrapperAntd = ({ startIcon, endIcon, children, style }) => {
	if (!children) return null;
    const isMultiple = children?.props?.mode === 'multiple';
	return (
		<div
			style={{
				position: 'relative',
				display: 'inline-flex',
				alignItems: 'center',
				width: style?.width || (children.props.style && children.props.style.width) || 240,
				...style,
			}}
		>
			{startIcon && (
				<span
					style={{
						position: 'absolute',
						left: 16,
						zIndex: 2,
						display: 'flex',
						alignItems: 'center',
						pointerEvents: 'none',
					}}
				>
					{startIcon}
				</span>
			)}
			{endIcon && (
				<span
					style={{
						position: 'absolute',
						right: 16,
						zIndex: 2,
						display: 'flex',
						alignItems: 'center',
						pointerEvents: 'none',
					}}
				>
					{endIcon}
				</span>
			)}
			{React.cloneElement(children, {
				style: {
					width: '100%',
					...(children.props.style || {}),
				},
				// Inject extra padding so text does not overlap icons
				dropdownMatchSelectWidth: true,
				className: [
					children.props.className,
					'select-icon-wrapper--select',
					startIcon ? 'with-start' : '',
					endIcon ? 'with-end' : '',
					!isMultiple ? 'is-single' : '',
					
				]
					.filter(Boolean)
					.join(' '),
			})}
			<style>
				{`
          .ant-select .ant-select-arrow {
           font-size: 12px;
           margin-right: 6px;
          }
          .select-icon-wrapper--select .ant-select-selector {
            padding-left: 8px;
            padding-right: 8px;
            border-radius: 30px;
            border: 0px;
            font-size: 12px;
            font-weight: 500;
            color: #545460;
			background: #fff !important;
            font-family: 'Inter', sans-serif;
          }
          .select-icon-wrapper--select.with-start .ant-select-selector {
            padding-left: 38px !important;
          }
          .select-icon-wrapper--select.with-end .ant-select-selector {
            padding-right: 32px !important;
          }

          /* Move the search input start (showSearch mode) */
          .select-icon-wrapper--select.with-start.is-single .ant-select-selector .ant-select-selection-search {
            inset-inline-start: 32px !important;
          }

          /* Also shift placeholder text when no value */
          .select-icon-wrapper--select.with-start .ant-select-selection-placeholder {
            margin-left: 32px !important;
			font-size: 12px;
			font-weight: 500;
			color: #545460;
			font-family: 'Inter', sans-serif;
          }

          
			.select-icon-wrapper--select .ant-select-selection-item-remove {
    display: none !important;
  }
        `}
			</style>
		</div>
	);
};

export default SelectIconWrapperAntd;
